import React from "react";
import { RouteComponentProps } from "react-router";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { KIT_SLIDER, KitProfileLocation } from "@navigation";
import { bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { KitSearchFiltersProvider } from "./hooks/use-booking-kit-search-filters";
import { Box, ThemeProvider } from "@material-ui/core";
import { BookingKitSearchLayout } from "./booking-kit-search-layout";

type Props = RouteComponentProps<any>;

export function BookingKitSearchPage(props: Props) {
  const { match } = props;
  const { url } = match;
  return (
    <>
      {catchDirectUrl(url)}
      <ThemeProvider theme={bonlivaPipelineTheme}>
        <KitSearchFiltersProvider>
          <Box
            width="100%"
            height="100%"
            fontFamily={bonlivaPipelineTheme.typography.fontFamily}
          >
            <BookingKitSearchLayout />
          </Box>
        </KitSearchFiltersProvider>
      </ThemeProvider>
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute([`${url}/:kitId(\\S{24})`], KIT_SLIDER, ({ kitId }) => {
    if (kitId) {
      return new KitProfileLocation(kitId);
    }
  });
}
